import React, { useEffect, useState } from "react";

import { addUser, getUserList } from "../../../services/Users-services";

import {
  getExaminationTemplateShareDetails,
  updateExaminationTemplateShareStatus,
  getExaminationTemplateShareList,
  deleteExaminationTemplateShare,
  addExaminationTemplateShare,
} from "../../../services/Users-services";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,

} from "../../../../src/services/utilityFunctions.js";

import { useGlobalState } from "../../../../src/services/hostelConst";
import Select from "react-select";
import { getLocalStorageData } from "../../../services/axiosComponent";
import { selectStyle } from "../../../services/constant";
import { useDispatch,useSelector } from "react-redux";
import {
  openModal,
  closeModal,
} from "../../../services/redux/reducers/modalSlice";
const ShareTemplateForm = ({ navigate, refresh, details }) => {
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modal);

  const id = modal.data?._ID; // Get id from modal data
  const templateId = details._ID; // Use details._ID as templateId

   // Assuming templateId is passed in modal
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [isUserLoading, setIsUserLoading] = useState(false);

  const permissionOptions = [
    { value: "READ", label: "Read Only" },
    { value: "WRITE", label: "Read & Write" },
    { value: "FULL", label: "FULL" },
  ];

  const prepareFormData = (data = null) => {
    return {
      userId: {
        value: data != null ? data["_USER ID"] : "",
        label: data != null ? data["NAME"] : "",
      },
      permission: {
        value: data != null ? data.PERMISSION : "",
        label:
          data != null
            ? data.PERMISSION === "Read"
              ? "Read Only"
              : data.PERMISSION === "Write"
              ? "Read & Write"
              : data.PERMISSION === "Full"
              ? "FULL"
              : ""
            : "",
      },
    };
  };
  const [loadingData, setLoadingData] = useState(modal.isEditing);
  const [formData, setFormData] = useState(prepareFormData());

  const getShareTemplateDetailsData = async (shareId) => {
    setFormData(prepareFormData(modal.data));
    setLoadingData(false);
  };

  const handleChange = (field, value) => {
    setErrors({});
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    let isValid = true;
    let errors = {};

    if (formData.userId.value == "") {
      isValid = false;
      errors.userId = "User is required";
    }
    if (formData.permission.value == "") {
      isValid = false;
      errors.permission = "Permission is required";
    }
    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);
      console.log("modal.data", modal);
      var submitData = {
        templateId: details._ID, // Assuming templateId is part of details
        userId: formData.userId.value,
        permission: formData.permission.value.toUpperCase(),
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
        regionId: details._REGION,
        siteId: details._SITE,
        // entityId: modal.isEditing ? modal.data._ID : null,
      };

      var res = 
         await addExaminationTemplateShare(submitData);

      if (res.status == "success") {
        callToast("success", "Success", "Template shared successfully");

        await refresh({ columnRefresh: false, isLoading: false });
        setLoading(false);

       dispatch(closeModal()); // Close modal after successful submission
      } else {
        console.log(res, "share template response");
        setLoading(false);
        showErrorMessages({
          data: res,
          navigate,
        });
      }
    }
  };

  const getUserListData = async ({ query = null } = {}) => {
    setIsUserLoading(true);
    var res = await getUserList({
      query: query,

      status: "Y",
    });
    if (res.status == "fail") {
      showErrorMessages({ data: res, navigate });
    } else {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      setIsUserLoading(false);
      setUserOptions(list);
    }
  };

  useEffect(() => {
    getUserListData(); // Load users initially
    console.log("modal.isEditing", modal.isEditing);
    if (modal.isEditing == true) {
      getShareTemplateDetailsData(id);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only"></span>
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            <div className="d-flex">
              <div className="w-100 ps-5 pe-5">
                <form>
                  <>
                    <div className="mb-3 ">
                      <label className="form-label">User</label>

                      <Select
                        styles={selectStyle}
                        options={userOptions}
                        value={
                          formData.userId.label == "" ? null : formData.userId
                        }
                        components={
                          isUserLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "userId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            getUserListData({
                              query: inputValue,
                            });
                          }
                        }}
                        noOptionsMessage={() => {
                          return "No users available";
                        }}
                        isSearchable={true}
                        placeholder="Select User"
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.userId && (
                        <small className="text-danger">{errors.userId}</small>
                      )}
                    </div>

                    <div className="mb-3 ">
                      <label className="form-label">Permission</label>

                      <Select
                        styles={selectStyle}
                        options={permissionOptions}
                        value={
                          formData.permission.label == ""
                            ? null
                            : formData.permission
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "permission",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        noOptionsMessage={() => {
                          return "No permissions available";
                        }}
                        isSearchable={false}
                        placeholder="Select Permission"
                        className="basic-single"
                        classNamePrefix="select"
                      />
                      {errors.permission && (
                        <small className="text-danger">
                          {errors.permission}
                        </small>
                      )}
                    </div>
                  </>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default ShareTemplateForm;
